import { isNull, isUndefined, round } from 'lodash';

import { DEFAULT_VALUE_MAX, DEFAULT_VALUE_MIN, Increment } from 'core/rating/types';

/** ensures min/max range values are handled as integers */
export const parseRangeValue = (rangeValueRaw: number | undefined, defaultValue = 0): number => {
    const value = (isUndefined(rangeValueRaw) ? defaultValue : Math.round(rangeValueRaw)) as number;

    return value;
};

export const roundValue = (valueRaw: number, increment: Increment): number => {
    let value;

    if (increment === Increment.Whole) {
        value = Math.round(valueRaw);
    } else {
        value = Math.round(valueRaw * 10) / 10;

        if (increment === Increment.Half) {
            const values = String(valueRaw).split('.');
            const integerValue = parseInt(values[0], 10);

            if (values.length === 2) {
                const fractionValue = parseInt(values[1], 10);

                if (fractionValue < 5) {
                    value = integerValue;
                } else if (fractionValue > 5) {
                    value = integerValue + 1;
                }
            }
        }
    }

    return value;
};

export const getPotentialIncrementedValues = (value: number, increment: Increment): number[] => {
    const incrementedValues = [value];

    switch (increment) {
        case Increment.Half:
            incrementedValues.push(value - 0.5);
            break;
        case Increment.Point:
            for (let i = 9; i > 0; i--) {
                incrementedValues.push(round(value - 0.1 * i, 1));
            }
            break;
        default:
    }

    incrementedValues.sort();

    return incrementedValues;
};

export const getPotentialIntegerValues = (valueMin: number, valueMax: number): number[] => {
    const potentialValues: number[] = [];
    const startingValue = parseRangeValue(valueMin, DEFAULT_VALUE_MIN);
    const endingValue = parseRangeValue(valueMax, DEFAULT_VALUE_MAX);

    for (let i = startingValue; i <= endingValue; i++) {
        potentialValues.push(i);
    }

    return potentialValues;
};

export const isUnrated = (selectedValue?: number | null): boolean =>
    isNull(selectedValue) || isUndefined(selectedValue) || selectedValue === 0;
